// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"97001a92","513":"7a382833","787":"7699acdd"}[chunkId] + ".chunk.js";
};